import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Subscription } from 'rxjs';
import { Utility } from 'src/app/utils/app-utils';
import { UserSessionStateService } from 'src/app/services/user-session-state.service';
import { AlarmService } from 'src/app/services/alarm.service';

@Component({
  selector: 'app-feeds',
  templateUrl: './feeds.component.html',
  styleUrls: ['./feeds.component.scss']
})
export class FeedsComponent implements OnInit, OnDestroy {
  videoFeedsFlipped: boolean = false;
  getThermalStateSubscriber: Subscription;
  getThermalSubscriber: boolean;
  isThermal: boolean = false;
  selectedAlarmId: string;

  constructor(private userSessionStateService: UserSessionStateService, private alarmService: AlarmService) { }

  ngOnInit() {
    this.getThermalSubscriber = this.userSessionStateService.getThermalState();
    this.getThermalStateSubscriber = this.userSessionStateService.getThermalStateChangeNotification().subscribe((state) => {
      this.getThermalSubscriber = state;
      if (this.alarmService.selectedAlarm) {
        this.selectedAlarmId = this.alarmService.selectedAlarm.id;
      }
      this.isThermal = this.getThermalSubscriber;
    });
  }

  flipVideoFeeds() {
    this.videoFeedsFlipped = !this.videoFeedsFlipped;
  }

  ngOnDestroy() {
    this.getThermalStateSubscriber = Utility.Unsubscribe(this.getThermalStateSubscriber);
  }

}
